export default function getDefaultNewItem (uid, timestamp) {
  return {
    itemId: uid,
    contentType: 'Item',
    itemType: 'Multiple Choice',
    shuffle: false,
    question: '',
    answers: [
      {
        correct: true,
        answer: '',
        feedback: '',
      },
      {
        correct: false,
        answer: '',
        feedback: '',
      },
      {
        correct: false,
        answer: '',
        feedback: '',
      },
      {
        correct: false,
        answer: '',
        feedback: '',
      }
    ],
    activeEdit: {
      type: '',
      index: 0,
    },
    createdDate: timestamp,
    lastModifiedDate: timestamp,
    startingLetter: 'a',
    nodeTags: null,
    name: '',
    code: '',
    passage: '',
  }
}



/*

    answers: [
      {
        correct: true,
        answer: 'Add answer here...',
        feedback: 'Add explanation here...',
      },
      {
        correct: false,
        answer: 'Add answer here...',
        feedback: 'Add explanation here...',
      },
      {
        correct: false,
        answer: 'Add answer here...',
        feedback: 'Add explanation here...',
      },
      {
        correct: false,
        answer: 'Add answer here...',
        feedback: 'Add explanation here...',
      }
    ],


    */


// WEBPACK FOOTER //
// ./src/helpers/getDefaultNewItem.js